"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarFallback = void 0;
var _react = _interopRequireWildcard(require("react"));
var _boringAvatars = _interopRequireDefault(require("boring-avatars"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
/**
 * UI that renders when image provided to Avatar component
 * fails to load or no image is provided
 * @param {object} props
 * @param {string} props.name - Name is used to render a BoringAvatar gradient
 * specific to the user the Avatar is representing.
 * The component will also use the name to render initials for the user.
 * @param {number} props.size - Height and width of the component
 * @param {'circle' | 'square'} props.shape

 */
var AvatarFallback = function AvatarFallback(_ref) {
  var name = _ref.name,
    size = _ref.size,
    shape = _ref.shape,
    className = _ref.className;
  // SVG pattern is derived from string passed into BoringAvatar name property
  // So even though the rendered text is just the initials, the pattern can be
  // based on the full name to avoid repetition for common initials
  var initials = (0, _react.useMemo)(function () {
    return (0, _utils.personInitials)(name);
  }, [name]);
  var isSquare = shape === 'square';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('--tag-monument-avatar-fallback', 'relative flex items-center', className),
    style: {
      height: size,
      width: size
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('absolute select-none text-white uppercase w-full text-center initials tw-caption-regular')
    // Make font size proportional to size of avatar
    ,
    style: {
      fontSize: size * 0.325
    }
  }, initials), /*#__PURE__*/_react.default.createElement(_boringAvatars.default, {
    name: name,
    size: size,
    variant: "marble",
    colors: ['#35846B', '#2980D6', '#BA3962', '#D5421E', '#228291'],
    square: isSquare
  }));
};
exports.AvatarFallback = AvatarFallback;